import Controller from "./universal.controller";
import template from "./universal.html";

const universal = {
  template,
  controller: Controller,
};

export default universal;



// WEBPACK FOOTER //
// ./src/pages/universal/universal.component.js